<template>
  <prism language="javascript">{{ data.content }}</prism>
</template>

<script>
import "prismjs/prism.js";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-javascript";
import Prism from "vue-prism-component";

export default {
  components: {
    Prism,
  },
  
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
